import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="/" className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-900 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-md font-body text-sm font-bold">
                CS
              </span>
              CSSBuy Spreadsheet
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('home_seo_description')}
            </p>
            <div className="mt-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors"
              >
                {t('hero_cta_primary')}
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t('footer_resources')}
            </h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav_spreadsheet')}</a></li>
              <li><a href="/article/cssbuy-review-2026" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav_reviews')}</a></li>
              <li><a href="/article/cssbuy-shipping-cost" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav_shipping')}</a></li>
              <li><a href="/article/cssbuy-coupon" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav_coupons')}</a></li>
              <li><a href="/article/cssbuy-safety-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav_safety')}</a></li>
              <li><a href="/article/cssbuy-warehouse-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav_warehouse')}</a></li>
              <li><a href="/guides" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav_guides')}</a></li>
              <li><a href="/article/cssbuy-faq" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav_faq')}</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t('footer_company')}
            </h4>
            <ul className="space-y-2">
              <li><a href="/article/about-us" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('about_us')}</a></li>
              <li><a href="/article/editorial-policy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('editorial_policy')}</a></li>
              <li><a href="/article/disclaimer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('disclaimer')}</a></li>
              <li><a href="/article/privacy-policy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('privacy')}</a></li>
              <li><a href="/article/contact" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav_contact')}</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              CSSBuy Spreadsheet
            </h4>
            <p className="text-sm text-foreground-600 mb-4">
              Stay updated with the latest guides, tips, and resources for CSSBuy research.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-4 py-2 border border-primary-300 text-primary-700 text-sm font-medium rounded-lg hover:bg-primary-50 transition-colors"
            >
              <i className="ri-external-link-line" />
              {t('main_cta_button')}
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-background-200/70">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 text-center md:text-left">
              {t('footer_disclaimer')}
            </p>
            <p className="text-xs text-foreground-400">
              © {new Date().getFullYear()} CSSBuy Spreadsheet. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}